import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestFormPage.QBooksJournalEntryRequestForm', {
    headerText: 'Journal Entry details',
    memo: 'Memo',
    memoPlaceholder: 'Enter value',
    mandatoryFieldsError: 'Please fill all mandatory fields.',
    debitCreditError: 'Debit and Credit amounts are not equal.',
    accountPayablePayeeTypeMismatchError: 'Accounts Payable (A/P) account: needs to have a Vendor in the Type Field.',
    accountReceivablePayeeTypeMismatchError:
        'Accounts Receivable (A/R) account: needs to have a Customer in the Type Field.',
    journalNumberLengthError: 'Journal # can’t exceed 21 symbols',
    purchases: 'Purchases',
    sales: 'Sales',
});
